import { offset, shift, flip } from '@floating-ui/react';
import {
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG,
    TAG_SIZE_NON_ADMIN_EXPANDED,
} from '../constant';

export type Placement = 'left-start' | 'right-start';

/**
 * `ref` is the image box the tag sits on. Floating UI rendered inside that box
 * is kept within it. Portalled UI is outside the box, so nothing clips it, and
 * it is kept within the viewport instead: the revamp's rounded image clips its
 * children, and a box too small for the card cannot hold it at all.
 */
export const getConfigPopper = (
    ref: Element,
    placement: Placement = 'left-start',
    isPortalled = false,
) => {
    const boundary = isPortalled ? 'clippingAncestors' : ref;
    return {
        placement,
        strategy: 'absolute' as const,
        middleware: [
            // react-popper `offset` was [skidding, distance] == [crossAxis, mainAxis].
            offset({
                mainAxis: PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG,
                crossAxis: (TAG_SIZE_NON_ADMIN_EXPANDED / 2) * -1,
            }),
            // react-popper enabled `flip` by default; keep it on for parity.
            flip({
                boundary,
                padding: PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
            }),
            // Maps react-popper `preventOverflow` (boundary + rootBoundary were the same box element).
            shift({
                boundary,
                padding: PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
            }),
        ],
    };
};
